<template>
  <div id="app" class="animated fadeIn">
    <Header></Header>
    <router-view />
    <Footer></Footer>
    <!-- <GoTop></GoTop> -->
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "App",
  data() {
    return {
    }
  },
  computed: {
    ...mapState(['languageType'])
  },
  watch: {
    $route(to, from) {
      console.log('router=======');
      // if (to.meta.type === 'en') {
      //   this.$store.commit("changeLan", 'en');
      // } else {
      //   this.$store.commit("changeLan", 'cn');
      // }
    },
  },
  mounted() {
    this.$showLoading();
    if (document.body.clientWidth < 750) {
      //window.location.href = 'https://web-test.peets.cn/m/';
      window.location.href = 'https://www.peets.cn/m/';
    };
    //当然随时改变屏幕大小也会改变的，所以也要加上
    window.addEventListener('resize', () => {
      if (document.body.clientWidth < 750) {
        //window.location.href = 'https://web-test.peets.cn/m/';
        window.location.href = 'https://www.peets.cn/m/';
      }
    })
    //this.languageType = this.$store.state.languageType;
  },
};
</script>

<style lang="scss" scoped>
#app {
  font-family: "siyuanNormal";
  opacity: 0;
  animation-delay: .5s;
}
</style>



// WEBPACK FOOTER //
// src/App.vue